import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";

import {
  SUPPORT_EMAIL_MAILTO,
  SUPPORT_EMAIL,
} from "shared/utils/siteConstants";

const AppError = ({
  className,
  children,
  hideAdvice,
}: {
  className?: string;
  children?: ReactNode;
  hideAdvice?: boolean;
}) => {
  return (
    <div className={`AppSpinner AppError ${className}`}>
      <FontAwesomeIcon
        className="AppSpinner-icon"
        icon="exclamation-triangle"
        color="darkred"
        fontSize="32px"
        aria-hidden={true}
      />
      {children}
      {!hideAdvice && (
        <>
          <h6 style={{ marginTop: "1em", fontStyle: "normal" }}>
            Please check your Internet connection
            <br />
            and try refreshing the page
          </h6>
          <h6 style={{ marginTop: "1em", fontStyle: "normal" }}>
            If you continue to see this message
            <br />
            contact <a href={SUPPORT_EMAIL_MAILTO}>{SUPPORT_EMAIL}</a>
          </h6>
        </>
      )}
    </div>
  );
};

export default AppError;
